export enum ApplicationStatus {
  PENDING = 'PENDING',
  ACCEPTED = 'ACCEPTED',
  BLOCKED = 'BLOCKED'
}

export enum DriverState {
  ACTIVE = 'ACTIVE',
  PASSIVE = 'PASSIVE'
}

export enum AppState {
  BACKGROUND = 'BACKGROUND',
  FOREGROUND = 'FOREGROUND'
}

export interface DriverResponse {
  id: number;
  fullName: string;
  phoneNumber: string;
  imageId: string;
  vehicleImageId: string;
  driverLicenceImageId: string;
  applicationStatus: ApplicationStatus;
  appState: AppState;
  applicationStatusBlockReason: string;
  balance: number;
  isWorking: boolean;
}

export interface AdminDriversResponse {
  driver: DriverResponse;
  driverState: DriverState;
}

export interface DriverLocationResponse {
  id: number;
  driverId: number;
  latitude: number;
  longitude: number;
  heading: number;
  appState: AppState;
  serverTimeIntervalUTC: number;
}

export interface AdminDriverDetailsResponse {
  driver: DriverResponse;
  driverState: DriverState;
  lastLocation: DriverLocationResponse | null;
}

export interface DriversRequest {
  searchQuery: string;
  page: number;
  pageSize: number;
  applicationStatus: ApplicationStatus | null;
  driverState: DriverState | null;
}

export interface ChangeDriverApplicationStatusRequest {
  driverId: number;
  applicationStatus: ApplicationStatus;
  blockReason: string | null;
}

export interface ChangeDriverBalanceRequest {
  driverId: number;
  balance: number;
}

export interface DriversMapSearchRequest {
  radius: number;
  limit: number;
  centerLatitude: number;
  centerLongitude: number;
}

export enum TransactionType {
  FILL = 'FILL',
  WITHDRAW = 'WITHDRAW'
}

export interface DriverTransaction {
  id: number;
  driverId: number;
  transactionType: TransactionType;
  amount: number;
  descriptionHtml: string;
  createdAt: number;
  isDeleted: boolean;
}

export interface DriverTransactionsResponse {
  transactions: DriverTransaction[];
  page: number;
  pageSize: number;
  hasMore: boolean;
}

export interface CreateDriverTransactionRequest {
  driverId: number;
  transactionType: TransactionType;
  amount: number;
  descriptionHtml: string;
}

export interface CreateDriverTransactionResponse {
  transactionId: number;
}
